// extracted by mini-css-extract-plugin
export var legendIndicator = "_cb-1";
export var legendRight = "_cb-0";